module.exports = __webpack_public_path__ + "static/media/gr2.47e18ca8.png";